import normalize from 'json-api-normalizer';

import Survey from './survey';
import Task from './task';
import SurveyLink from './survey_link';
import ResultEntry from './result_entry';

export default class Result {
	static from (jsonapi) {
		let key = 'results'
		let normalizedJSONapi = normalize(jsonapi);
		if (!(Object.keys(normalizedJSONapi).includes(key))) return null;

		let keys = Object.keys(normalizedJSONapi[key]);
		if (keys.length > 0 && Array.isArray(jsonapi.data)) {
			let retVal = {};
			keys.forEach( function ( id ) {
				retVal[id] = Result.make(normalizedJSONapi[key][id], normalizedJSONapi);
			});
			return retVal;
		} else return Result.make(normalizedJSONapi[key][keys[0]], normalizedJSONapi);
	}

	static make(jsonapi, normalizedJSONapi, noRelationships=0) {
		const { id, attributes } = jsonapi;

		let relationships = {}
		if ('surveyId' in attributes && attributes['surveyId'] && normalizedJSONapi['surveys'] && noRelationships == 0) {
			relationships['survey'] = Survey.make(normalizedJSONapi['surveys'][attributes['surveyId']], normalizedJSONapi);
		}

		if ('surveyLinkId' in attributes && attributes['surveyLinkId'] && normalizedJSONapi['surveyLinks'] && noRelationships == 0) {
			relationships['surveyLink'] = SurveyLink.make(normalizedJSONapi['surveyLinks'][attributes['surveyLinkId']], normalizedJSONapi);
		}

		if ('taskId' in attributes && attributes['taskId'] && normalizedJSONapi['tasks'] && noRelationships == 0) {
			relationships['task'] = Task.make(normalizedJSONapi['tasks'][attributes['taskId']], normalizedJSONapi);
		}

		if (jsonapi.relationships && jsonapi.relationships['resultEntry'] && normalizedJSONapi['resultEntries'] && noRelationships == 0) {
			relationships['resultEntries'] = {};
			jsonapi.relationships['resultEntry'].data.forEach( function (rel) {
				relationships['resultEntries'][rel.id] = ResultEntry.make(normalizedJSONapi[rel.type][rel.id], normalizedJSONapi);
			});
		}

		return new Result ( Object.assign({id: id}, attributes, relationships) );
	}

	constructor ({ id, completedAt, surveyId, survey, surveyLinkId, surveyLink, taskId, task, resultEntries }) {
		this.id             = id ? id : -1;
		this.complete       = (completedAt != null);
		this.completed_at   = completedAt;
		this.survey_id      = surveyId ? surveyId : -1;
		this.survey         = survey ? survey : null;
		this.survey_link_id = surveyLinkId ? surveyLinkId : -1;
		this.survey_link    = surveyLink ? surveyLink : null;
		this.task_id        = taskId ? taskId : -1;
		this.task           = task ? task : null;
		this.result_entries = resultEntries ? resultEntries : [];
	}

	resultJSdata() {
		let b = {}
		let sortedEntries = Object.values(this.result_entries).sort((a,b) => a.question.number - b.question.number);
		for (let i = 0; i < sortedEntries.length; i++) {
			let reobj = sortedEntries[i];
			let revobjs = Object.values(reobj.result_entry_values)
			let child = !(reobj.question.parent == null)

			if (child) {
				if (!(reobj.question.parent.varname in b)) {
					b[reobj.question.parent.varname] = {}
				}
			}

			if (revobjs.length == 1 && reobj.question.question_type_id != 3) { // Not checkbox because always Array
				if (revobjs[0].question_choice != null) {
					if (child) { // Matrix
						b[reobj.question.parent.varname][reobj.question.varname] = String(revobjs[0].question_choice.value);
					} else {
						b[reobj.question.varname] = revobjs[0].question_choice.value;
					}
				} else {
					if (child) { // Matrix
						b[reobj.question.parent.varname][reobj.question.varname] = (revobjs[0].text == "true") ? true : ((revobjs[0].text == "false") ? false : revobjs[0].text )
					} else {
						b[reobj.question.varname] = (revobjs[0].text == "true") ? true : ((revobjs[0].text == "false") ? false : revobjs[0].text )
					}
				}
			} else { // Arrays
				if (child) { // Matrix
					b[reobj.question.parent.varname][reobj.question.varname] = revobjs.map( (revobj) => {
						if (revobj.question_choice != null) {
							return String(revobj.question_choice.value);
						} else {
							return ((revobj.text == "true") ? true : ((revobj.text == "false") ? false :revobj.text ))
						}
					});
				} else {
					b[reobj.question.varname] = revobjs.map( (revobj) => {
						if (revobj.question_choice != null) {
							return revobj.question_choice.value;
						} else {
							return ((revobj.text == "true") ? true : ((revobj.text == "false") ? false : revobj.text ))
						}
					});
				}
			}
		}

		return b;
	}

	toJSONapi () {
		let attributes = Object.assign({}, this);
		delete attributes.id;

		return { data: { type: "results", id: this.id, attributes } }
	}
}
